import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import locationData from "../../countries.json";
import CustomSelect from "../CustomSelect";
import DatePicker from "react-datepicker";

const PersonalData = ({ formik }) => {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const data = locationData.map((country) => ({
      label: country.name,
      value: country.iso3,
    }));
    setCountries(data);
  }, []);

  const sexOptions = [
    { value: "MALE", label: t("form.man") },
    { value: "FEMALE", label: t("form.woman") },
    { value: "NOT DECLARED", label: t("form.nd") },
  ];

  return (
    <>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.firstname")} *</Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder={t("form.firstname")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            isInvalid={formik.touched.name && !!formik.errors.name}
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.name}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.lastname")} *</Form.Label>
          <Form.Control
            type="text"
            name="surName"
            placeholder={t("form.lastname")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.surName}
            isInvalid={formik.touched.surName && !!formik.errors.surName}
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.surName}`)}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.dob")} *</Form.Label>
          <DatePicker
            selected={
              formik.values.dateOfBirth
                ? new Date(formik.values.dateOfBirth)
                : null
            }
            onChange={(date) => {
              const formattedDate = date
                ? date.toISOString().split("T")[0]
                : "";
              formik.setFieldValue("dateOfBirth", formattedDate);
            }}
            dateFormat="dd/MM/yyyy"
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100}
            maxDate={new Date()}
            className={`form-control ${
              formik.touched.dateOfBirth && formik.errors.dateOfBirth
                ? "is-invalid"
                : ""
            }`}
            placeholderText={t("form.dob")}
            wrapperClassName="datePicker"
          />
          {formik.touched.dateOfBirth && formik.errors.dateOfBirth && (
            <div className="invalid-feedback d-block">
              {t(`error.${formik.errors.dateOfBirth}`)}
            </div>
          )}
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.sex")} *</Form.Label>
          <CustomSelect
            formik={formik}
            name="sex"
            options={sexOptions}
            placeholder={t("form.select")}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.birthPlace")} *</Form.Label>
          <Form.Control
            type="text"
            name="placeOfBirth"
            placeholder={t("form.birthPlace")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.placeOfBirth}
            isInvalid={
              formik.touched.placeOfBirth && !!formik.errors.placeOfBirth
            }
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik.errors.placeOfBirth}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.birthCountry")} *</Form.Label>
          <CustomSelect
            formik={formik}
            name="provinceOfBirth"
            options={countries}
            placeholder={t("form.birthCountry")}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("form.mobileNumber")} *</Form.Label>
          <PhoneInput
            international
            defaultCountry="US"
            name="mobilePhone"
            onChange={(value) => formik.setFieldValue("mobilePhone", value)}
            onBlur={formik.handleBlur}
            value={formik.values.mobilePhone}
            required={true}
            className={
              formik.errors.mobilePhone && formik.touched.mobilePhone
                ? "is-invalid"
                : ""
            }
          />
          <Form.Control.Feedback type="invalid">
            {t(`error.${formik?.errors?.mobilePhone}`)}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} className="mb-3">
          <Form.Label>{t("telephone")}</Form.Label>
          <Form.Control
            type="text"
            name="telephone"
            placeholder={t("form.telephone")}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.telephone}
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default PersonalData;